import { EKycVerificationStatus } from '@exam-center/graphql';

import { ExamineeProgressIcon, type ExamineeProgressIconVariant } from '../examinee-progress-icon';

interface ExamineeMonitorEkycIconProps {
  status: EKycVerificationStatus;
}

const EKYC_STATUS_VARIANT_MAP: Record<string, ExamineeProgressIconVariant> = {
  [EKycVerificationStatus.Approved]: 'completed',
  [EKycVerificationStatus.Rejected]: 'canceled',
  [EKycVerificationStatus.InProgress]: 'in-progress',
  [EKycVerificationStatus.PendingApproval]: 'pending',
  [EKycVerificationStatus.Expired]: 'expired',
  [EKycVerificationStatus.NotRequired]: 'not-required',
};

export default function ExamineeMonitorEkycIcon({
  status,
}: Readonly<ExamineeMonitorEkycIconProps>) {
  const variant = EKYC_STATUS_VARIANT_MAP[status] ?? 'disabled';

  return <ExamineeProgressIcon variant={variant} />;
}
